import { useEffect, useState } from "react";

const MOBILE_MAX = 767;
const TABLET_MIN = 768;
const TABLET_MAX = 1223;
const DESKTOP_MIN = 1441;

export const useBreakpoints = () => {
  const getDevice = () => {
    if (typeof window === "undefined")
      return { isMobile: false, isTablet: false, isDesktop: false };

    const width = window.innerWidth;

    return {
      isMobile: width <= MOBILE_MAX,
      isTablet: width >= TABLET_MIN && width <= TABLET_MAX,
      isDesktop: width >= DESKTOP_MIN,
    };
  };

  const [breakpoints, setBreakpoints] = useState(getDevice);

  useEffect(() => {
    const handleResize = () => {
      setBreakpoints(getDevice());
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return breakpoints; // { isMobile, isTablet, isDesktop }
};
